
// SVG Icon: compare
export default { id: "terriajs-compare" };
export const id = "terriajs-compare";
export const name = "compare";
